import React from 'react'

import { Navigate, useLocation } from 'react-router-dom'
import { useZxContext } from '../zxContext'
// import useStore from '@src/stores/user'

const PrivateRoute = (props) => {
	const location = useLocation()
	const { pathname } = location
	const { isLogin, userinfo } = useZxContext() // 这里做登录验证

	if (isLogin === false) {
		return <Navigate to={{ pathname: `/login` }} replace />
	}

	if (pathname === '/') {
		if (userinfo.role === 0) {
			return <Navigate to={{ pathname: `/dashboard/learn` }} replace  />
		} else if (userinfo.role === 1) {
			return <Navigate to={{ pathname: `/unit/dashboard/learn` }} replace />
		}
	}
	return props.element

}

export default PrivateRoute
